/*
 *
 * QuestionnairePage actions
 *
 */

import {
  STORE_QUESTIONNAIRE,
  STORE_QUESTIONNAIRE_SUCCESS,
  STORE_QUESTIONNAIRE_ERROR,
  STORE_QUESTIONNAIRE_TEXTS,
  STORE_QUESTIONNAIRE_TEXTS_SUCCESS,
  STORE_QUESTIONNAIRE_TEXTS_ERROR,
  STORE_DISQUALIFICATION_RULES,
  STORE_DISQUALIFICATION_RULES_SUCCESS,
  STORE_DISQUALIFICATION_RULES_ERROR,
  FETCH_QUESTIONNAIRE,
  FETCH_QUESTIONNAIRE_SUCCESS,
  FETCH_QUESTIONNAIRE_ERROR,
  UPDATE_QUESTIONNAIRE,
  UPDATE_QUESTIONNAIRE_LOGIC,
  ADD_QUESTION_TO_QUESTIONNAIRE,
  REMOVE_QUESTION_FROM_QUESTIONNAIRE,
  SET_ACTIVE_NODE,
  UPDATE_VALIDATION_ERRORS,
  SHOW_ALL_ERRORS,
  UPDATE_GROUP_PROPERTIES,
  SET_QUESTIONNAIRE_SHUFFLING,
  MOVE_QUESTION,
  SHOW_MOVE_QUESTION_MODAL,
  CLOSE_MOVE_QUESTION_MODAL,
  INSERT_RECALL,
  MOVE_NODE,
  MOVE_NODES_TO_GROUP,
  REMOVE_GROUP_KEEP_NODES,
  TOGGLE_MODAL,
  AB_ADD_CONCEPT,
  AB_UPDATE_CONCEPT,
  AB_REMOVE_CONCEPT,
  GROUP_ADD_ATTRIBUTE,
  GROUP_UPDATE_ATTRIBUTE,
  GROUP_UPDATE_ATTRIBUTE_VALUE,
  AB_ADD_DEFAULT_NODES,
  AB_UPDATE_PROPERTIES,
  VAN_WESTENDORP_UPDATE_SETTINGS,
  VAN_WESTENDORP_UPDATE_LIKELIHOOD,
  MATRIX_OPEN_ENDED_UPDATE_SETTINGS,
  GROUP_REMOVE_ATTRIBUTE,
  GROUP_REMOVE_LOOP_AND_MERGE_CONCEPT,
  GROUP_RE_ORDER_LOOP_AND_MERGE_CONCEPT,
  FETCH_DEMOGRAPHICS,
  FETCH_DEMOGRAPHICS_SUCCESS,
  FETCH_DEMOGRAPHICS_ERROR,
  CONJOINT_UPDATE_PROPERTIES,
  DOE_UPDATE_GROUP_AND_PROPERTIES,
  CONJOINT_MOVE_ATTRIBUTE,
  FETCH_DESIGN_OF_EXPERIMENT,
  FETCH_DESIGN_OF_EXPERIMENT_SUCCESS,
  FETCH_DESIGN_OF_EXPERIMENT_ERROR,
  DUPLICATE_MULTIPLE_QUESTIONS_TO_QUESTIONNAIRE,
  UPDATE_QUESTION_FAVORITE_STATE,
  TOGGLE_QUESTION_COLLAPSE,
  ADD_NODE,
  SET_REVISION_PREVIEW_MODE,
  FETCH_QUESTIONNAIRE_REVISIONS,
  FETCH_QUESTIONNAIRE_REVISIONS_SUCCESS,
  FETCH_QUESTIONNAIRE_REVISIONS_ERROR,
  FETCH_QUESTIONNAIRE_BY_REVISION,
  FETCH_QUESTIONNAIRE_BY_REVISION_ERROR,
  LOAD_QUESTIONNAIRE_REVISION,
  RENAME_QUESTIONNAIRE_REVISION,
  RENAME_QUESTIONNAIRE_REVISION_SUCCESS,
  RENAME_QUESTIONNAIRE_REVISION_ERROR,
  SAVE_QUESTIONNAIRE_REVISION,
  SAVE_QUESTIONNAIRE_REVISION_SUCCESS,
  SAVE_QUESTIONNAIRE_REVISION_ERROR,
  DELETE_QUESTIONNAIRE_REVISION,
  DELETE_QUESTIONNAIRE_REVISION_SUCCESS,
  DELETE_QUESTIONNAIRE_REVISION_ERROR,
  RESTORE_QUESTIONNAIRE_REVISION,
  SET_REVISION_PREVIEW_MODE_SUCCESS,
  UPDATE_QUESTIONNAIRE_EXTERNAL,
  REVERT_QUESTIONNAIRE_REVISION_LATEST_AI,
  REVERT_QUESTIONNAIRE_REVISION_LATEST_AI_SUCCESS,
  REVERT_QUESTIONNAIRE_REVISION_LATEST_AI_ERROR,
  CLEAR_EXTERNAL_UPSERT_ADDITIONAL_INFO,
  GROUP_ADD_CONCEPT,
  LOOP_AND_MERGE_UPDATE_GROUP,
  LOOP_AND_MERGE_UPDATE_GROUP_SUCCESS,
  LOOP_AND_MERGE_UPDATE_PROPERTIES,
  FETCH_QUESTIONNAIRE_DIFF,
  FETCH_QUESTIONNAIRE_DIFF_SUCCESS,
  TOGGLE_NODE_VISIBILITY,
  VALIDATE_ALL_NODES,
  SET_NODE_QUOTA_MODE,
  TOGGLE_NODE_QUOTAS_SUCCESS,
  TOGGLE_NODE_QUOTAS_ERROR,
  CREATE_NODE_QUOTA_RULES,
  REMOVE_NODE_QUOTA_RULES,
  UPDATE_NODE_QUOTA_RULE_VALUE,
  SET_ANSWER_SCREENER_TYPE,
  RESET_SCREENER_TYPES,
} from './constants';

export function fetchQuestionnaireRevisions() {
  return {
    type: FETCH_QUESTIONNAIRE_REVISIONS,
  };
}

export function fetchQuestionnaireRevisionsSuccess(payload) {
  return {
    type: FETCH_QUESTIONNAIRE_REVISIONS_SUCCESS,
    payload,
  };
}

export function fetchQuestionnaireRevisionsError(error) {
  return {
    type: FETCH_QUESTIONNAIRE_REVISIONS_ERROR,
    error,
  };
}

export function fetchQuestionnaireByRevision(checkpointId) {
  return {
    type: FETCH_QUESTIONNAIRE_BY_REVISION,
    checkpointId,
  };
}

export function loadQuestionnaireRevision(payload) {
  return {
    type: LOAD_QUESTIONNAIRE_REVISION,
    payload,
  };
}

export function fetchQuestionnaireByRevisionError(error) {
  return {
    type: FETCH_QUESTIONNAIRE_BY_REVISION_ERROR,
    error,
  };
}

export function saveQuestionnaireRevision({
  checkpointName,
  checkpointDescription,
}) {
  return {
    type: SAVE_QUESTIONNAIRE_REVISION,
    checkpointName,
    checkpointDescription,
  };
}

export function saveQuestionnaireRevisionSuccess() {
  return {
    type: SAVE_QUESTIONNAIRE_REVISION_SUCCESS,
  };
}

export function saveQuestionnaireRevisionError(error) {
  return {
    type: SAVE_QUESTIONNAIRE_REVISION_ERROR,
    error,
  };
}

export function renameQuestionnaireRevision({
  checkpointName,
  checkpointDescription,
  checkpointId,
}) {
  return {
    type: RENAME_QUESTIONNAIRE_REVISION,
    checkpointName,
    checkpointDescription,
    checkpointId,
  };
}

export function renameQuestionnaireRevisionSuccess() {
  return {
    type: RENAME_QUESTIONNAIRE_REVISION_SUCCESS,
  };
}

export function renameQuestionnaireRevisionError(error) {
  return {
    type: RENAME_QUESTIONNAIRE_REVISION_ERROR,
    error,
  };
}

export function restoreQuestionnaireRevision(checkpointId) {
  return {
    type: RESTORE_QUESTIONNAIRE_REVISION,
    checkpointId,
  };
}

export function deleteQuestionnaireRevision(checkpointId) {
  return {
    type: DELETE_QUESTIONNAIRE_REVISION,
    checkpointId,
  };
}

export function deleteQuestionnaireRevisionSuccess(revisionId, revisions) {
  return {
    type: DELETE_QUESTIONNAIRE_REVISION_SUCCESS,
    revisionId,
    revisions,
  };
}

export function deleteQuestionnaireRevisionError(error) {
  return {
    type: DELETE_QUESTIONNAIRE_REVISION_ERROR,
    error,
  };
}

export function fetchQuestionnaire(id, showErrors) {
  return {
    type: FETCH_QUESTIONNAIRE,
    id,
    showErrors,
  };
}

export function fetchQuestionnaireSuccess(
  surveyDetails,
  showErrors,
  forceAcceptServerVersion = false,
) {
  return {
    type: FETCH_QUESTIONNAIRE_SUCCESS,
    payload: Object.assign({}, surveyDetails, { showErrors }),
    forceAcceptServerVersion,
  };
}

export function fetchQuestionnaireError(error) {
  return {
    type: FETCH_QUESTIONNAIRE_ERROR,
    error,
  };
}

export function updateQuestionnaire({ question, ...restData }) {
  return {
    type: UPDATE_QUESTIONNAIRE,
    question,
    ...restData,
  };
}

export function updateQuestionnaireLogic(costAffected) {
  return {
    type: UPDATE_QUESTIONNAIRE_LOGIC,
    costAffected,
  };
}

export function storeQuestionnaireSuccess(version) {
  return {
    type: STORE_QUESTIONNAIRE_SUCCESS,
    payload: version,
  };
}

export function storeQuestionnaireError(error) {
  return {
    type: STORE_QUESTIONNAIRE_ERROR,
    error,
  };
}

export function storeQuestionnaire({
  surveyId,
  questions,
  questionGroups,
  costAffected,
  logic,
  ql,
  disqualificationQl,
  version,
  questionGroupShuffle,
}) {
  return {
    type: STORE_QUESTIONNAIRE,
    surveyId,
    questions,
    questionGroups,
    costAffected,
    logic,
    ql,
    disqualificationQl,
    version,
    questionGroupShuffle,
  };
}

export function storeQuestionnaireTextsSuccess(version) {
  return {
    type: STORE_QUESTIONNAIRE_TEXTS_SUCCESS,
    payload: version,
  };
}

export function storeQuestionnaireTextsError(error) {
  return {
    type: STORE_QUESTIONNAIRE_TEXTS_ERROR,
    error,
  };
}

export function storeQuestionnaireTexts({
  surveyId,
  questions,
  questionGroups,
  version,
  disqualificationQl,
  ql,
  hiddenVariables,
  ruleEntries,
}) {
  return {
    type: STORE_QUESTIONNAIRE_TEXTS,
    surveyId,
    questions,
    questionGroups,
    version,
    disqualificationQl,
    ql,
    hiddenVariables,
    ruleEntries,
  };
}

export function storeDisqualificationRulesSuccess(version) {
  return {
    type: STORE_DISQUALIFICATION_RULES_SUCCESS,
    payload: version,
  };
}

export function storeDisqualificationRulesError(error) {
  return {
    type: STORE_DISQUALIFICATION_RULES_ERROR,
    error,
  };
}

export function storeDisqualificationRules({
  surveyId,
  disqualificationQl,
  version,
}) {
  return {
    type: STORE_DISQUALIFICATION_RULES,
    surveyId,
    disqualificationQl,
    version,
  };
}

// `screenerTypes` (`{ [answerRefId]: screenerType }`) carries the screener
// types of a duplicated screening question.
export function addQuestionToQuestionnaire({
  question,
  refId,
  direction,
  screenerTypes,
}) {
  return {
    type: ADD_QUESTION_TO_QUESTIONNAIRE,
    question,
    refId,
    direction,
    screenerTypes,
  };
}

export function duplicateMultipleQuestionsToQuestionnaire(payload) {
  return {
    type: DUPLICATE_MULTIPLE_QUESTIONS_TO_QUESTIONNAIRE,
    payload,
  };
}

export function updateQuestionFavoriteState(payload) {
  return {
    type: UPDATE_QUESTION_FAVORITE_STATE,
    payload,
  };
}

export function removeQuestionFromQuestionnaire(payload) {
  return {
    type: REMOVE_QUESTION_FROM_QUESTIONNAIRE,
    payload,
  };
}

export function setActiveNode(payload) {
  return {
    type: SET_ACTIVE_NODE,
    payload,
  };
}

export function updateValidationErrors(questionId, errors = {}, category) {
  return {
    type: UPDATE_VALIDATION_ERRORS,
    questionId,
    errors,
    category,
  };
}

export function showAllErrors() {
  return {
    type: SHOW_ALL_ERRORS,
  };
}

export function moveQuestion(payload) {
  return {
    type: MOVE_QUESTION,
    payload,
  };
}

export function setQuestionnaireShuffling(payload) {
  return {
    type: SET_QUESTIONNAIRE_SHUFFLING,
    payload,
  };
}

export function updateGroupProperties(payload) {
  return {
    type: UPDATE_GROUP_PROPERTIES,
    payload,
  };
}

export function showMoveQuestionModal(payload) {
  return {
    type: SHOW_MOVE_QUESTION_MODAL,
    payload,
  };
}

export function closeMoveQuestionModal(payload) {
  return {
    type: CLOSE_MOVE_QUESTION_MODAL,
    payload,
  };
}

export function insertRecall(refId) {
  return {
    type: INSERT_RECALL,
    refId,
  };
}

export function moveNode(payload) {
  return {
    type: MOVE_NODE,
    payload,
  };
}

export function moveNodesToGroup(payload) {
  return {
    type: MOVE_NODES_TO_GROUP,
    payload,
  };
}

export function removeGroupKeepNodes(payload) {
  return {
    type: REMOVE_GROUP_KEEP_NODES,
    payload,
  };
}

export function toggleModal(payload) {
  return {
    type: TOGGLE_MODAL,
    payload,
  };
}

export function abUpdateConcept(payload) {
  return {
    type: AB_UPDATE_CONCEPT,
    payload,
  };
}

export function abRemoveConcept(payload) {
  return {
    type: AB_REMOVE_CONCEPT,
    payload,
  };
}

export function groupAddConcept(payload) {
  return {
    type: GROUP_ADD_CONCEPT,
    payload,
  };
}

export function groupAddAttribute(payload) {
  return {
    type: GROUP_ADD_ATTRIBUTE,
    payload,
  };
}

export function groupUpdateAttribute(payload) {
  return {
    type: GROUP_UPDATE_ATTRIBUTE,
    payload,
  };
}

export function groupRemoveAttribute(payload) {
  return {
    type: GROUP_REMOVE_ATTRIBUTE,
    payload,
  };
}

export function groupReOrderLoopAndMergeConcept(payload) {
  return {
    type: GROUP_RE_ORDER_LOOP_AND_MERGE_CONCEPT,
    payload,
  };
}

export function groupRemoveConceptLoopAndMerge(payload) {
  return {
    type: GROUP_REMOVE_LOOP_AND_MERGE_CONCEPT,
    payload,
  };
}

export function groupUpdateAttributeValue(payload) {
  return {
    type: GROUP_UPDATE_ATTRIBUTE_VALUE,
    payload,
  };
}

export function abAddDefaultNodes(payload) {
  return {
    type: AB_ADD_DEFAULT_NODES,
    payload,
  };
}

export function loopAndMergeUpdateProperties(payload) {
  return {
    type: LOOP_AND_MERGE_UPDATE_PROPERTIES,
    payload,
  };
}

export function abUpdateProperties(payload) {
  return {
    type: AB_UPDATE_PROPERTIES,
    payload,
  };
}

export function vanWestendorpUpdateSettings(payload) {
  return {
    type: VAN_WESTENDORP_UPDATE_SETTINGS,
    payload,
  };
}

export function matrixOpenEndedUpdateSettings(payload) {
  return {
    type: MATRIX_OPEN_ENDED_UPDATE_SETTINGS,
    payload,
  };
}

export function vanWestendorpUpdateLikelihood(payload) {
  return {
    type: VAN_WESTENDORP_UPDATE_LIKELIHOOD,
    payload,
  };
}

export function fetchDemographics(surveyId, isPeeq) {
  return {
    type: FETCH_DEMOGRAPHICS,
    surveyId,
    isPeeq,
  };
}

export function fetchDemographicsSuccess(demographics) {
  return {
    type: FETCH_DEMOGRAPHICS_SUCCESS,
    demographics,
  };
}

export function fetchDemographicsError(error) {
  return {
    type: FETCH_DEMOGRAPHICS_ERROR,
    error,
  };
}

export function updatePropertiesOnConjointOrMaxDiff(payload) {
  return {
    type: CONJOINT_UPDATE_PROPERTIES,
    payload,
  };
}

export function doeUpdateGroupAndProperties(payload) {
  return {
    type: DOE_UPDATE_GROUP_AND_PROPERTIES,
    payload,
  };
}

export function conjointMoveAttribute(payload) {
  return {
    type: CONJOINT_MOVE_ATTRIBUTE,
    payload,
  };
}
export function abAddConcept(payload) {
  return {
    type: AB_ADD_CONCEPT,
    payload,
  };
}

export function fetchDesignOfExperiment(payload) {
  return {
    type: FETCH_DESIGN_OF_EXPERIMENT,
    payload,
  };
}

export function fetchDesignOfExperimentSuccess(payload) {
  return {
    type: FETCH_DESIGN_OF_EXPERIMENT_SUCCESS,
    payload,
  };
}

export function fetchDesignOfExperimentError(payload) {
  return {
    type: FETCH_DESIGN_OF_EXPERIMENT_ERROR,
    payload,
  };
}

export function toggleCollapse(questionRefId, groupRefId) {
  return {
    type: TOGGLE_QUESTION_COLLAPSE,
    questionRefId,
    groupRefId,
  };
}

export function addNode(payload) {
  return {
    type: ADD_NODE,
    payload,
  };
}

export function setRevisionPreviewMode(revision, isInRevisionPreviewMode) {
  return {
    type: SET_REVISION_PREVIEW_MODE,
    revision,
    isInRevisionPreviewMode,
  };
}

export function setRevisionPreviewModeSuccess(
  revision,
  isInRevisionPreviewMode,
) {
  return {
    type: SET_REVISION_PREVIEW_MODE_SUCCESS,
    revision,
    isInRevisionPreviewMode,
  };
}

export function revertQuestionnaireRevisionLatestAi() {
  return {
    type: REVERT_QUESTIONNAIRE_REVISION_LATEST_AI,
  };
}

export function revertQuestionnaireRevisionLatestAiSuccess() {
  return {
    type: REVERT_QUESTIONNAIRE_REVISION_LATEST_AI_SUCCESS,
  };
}

export function revertQuestionnaireRevisionLatestAiError(error) {
  return {
    type: REVERT_QUESTIONNAIRE_REVISION_LATEST_AI_ERROR,
    error,
  };
}

export function updateQuestionnaireExternal(payload) {
  return {
    type: UPDATE_QUESTIONNAIRE_EXTERNAL,
    payload,
  };
}

export function clearExternalUpsertAdditionalInfo() {
  return {
    type: CLEAR_EXTERNAL_UPSERT_ADDITIONAL_INFO,
  };
}

export function loopAndMergeUpdateGroup(payload) {
  return {
    type: LOOP_AND_MERGE_UPDATE_GROUP,
    payload,
  };
}
export function loopAndMergeUpdateGroupSuccess(payload) {
  return {
    type: LOOP_AND_MERGE_UPDATE_GROUP_SUCCESS,
    payload,
  };
}

export function fetchDiffAction(payload) {
  return {
    type: FETCH_QUESTIONNAIRE_DIFF,
    payload,
  };
}

export function fetchDiffSuccess(payload) {
  return {
    type: FETCH_QUESTIONNAIRE_DIFF_SUCCESS,
    payload,
  };
}

export function toggleNodeVisibility(payload) {
  return {
    type: TOGGLE_NODE_VISIBILITY,
    payload,
  };
}

export function validateAllNodes(payload) {
  return {
    type: VALIDATE_ALL_NODES,
    payload,
  };
}

/**
 * Request a question's answer quota mode. `mode: none` disables.
 */
export function setNodeQuotaMode({
  questionRefId,
  mode,
  saveCheckpoint = false,
}) {
  return {
    type: SET_NODE_QUOTA_MODE,
    payload: { questionRefId, mode, saveCheckpoint },
  };
}

export function toggleNodeQuotasSuccess(payload) {
  return {
    type: TOGGLE_NODE_QUOTAS_SUCCESS,
    payload,
  };
}
export function toggleNodeQuotasError(questionRefId, error) {
  return {
    type: TOGGLE_NODE_QUOTAS_ERROR,
    questionRefId,
    error,
  };
}

export function createNodeQuotaRules(questionRefId, totalCompletes, mode) {
  return {
    type: CREATE_NODE_QUOTA_RULES,
    questionRefId,
    // Ignored in min mode, where every answer starts at zero.
    totalCompletes,
    mode,
  };
}

export function removeNodeQuotaRules(questionRefId, matcher) {
  return {
    type: REMOVE_NODE_QUOTA_RULES,
    questionRefId,
    matcher,
  };
}

export function updateNodeQuotaRuleValue({
  questionRefId,
  ruleId,
  answerRefId,
  columnRefId,
  value,
}) {
  return {
    type: UPDATE_NODE_QUOTA_RULE_VALUE,
    questionRefId,
    ruleId,
    answerRefId,
    columnRefId,
    value,
  };
}

/**
 * Sets the screener type of a screening question's answer (or matrix cell,
 * with `columnRefId`).
 */
export function setAnswerScreenerType({
  questionRefId,
  answerRefId,
  columnRefId,
  screenerType,
}) {
  return {
    type: SET_ANSWER_SCREENER_TYPE,
    payload: { questionRefId, answerRefId, columnRefId, screenerType },
  };
}

// Makes every answer of a screening question allowed.
export function resetScreenerTypes({ questionRefId }) {
  return {
    type: RESET_SCREENER_TYPES,
    payload: { questionRefId },
  };
}
